export const GLOBAL_CONFIG = JSON.parse(process.env.NEXT_PUBLIC_GLOBAL_CONFIG || '{}') as GlobalEnv

// ENVIRONMENTS
export const IS_DEVELOPMENT_ENV = process.env.NEXT_PUBLIC_ENV === 'development'
  || process.env.NODE_ENV === 'development'

// DEPLOYMENTS
export const IS_PRODUCTION_DEPLOYMENT = process.env.NEXT_PUBLIC_DEPLOYMENT_NAME === 'production'
export const IS_PLAYGROUND_DEPLOYMENT = process.env.NEXT_PUBLIC_DEPLOYMENT_NAME === 'playground'
export const IS_PROD_PLAYGROUND_DEPLOYMENT = process.env.NEXT_PUBLIC_DEPLOYMENT_NAME === 'prod-playground'
export const IS_STAGING_DEPLOYMENT = process.env.NEXT_PUBLIC_DEPLOYMENT_NAME === 'staging'
export const IS_MAIN_DEPLOYMENT = process.env.NEXT_PUBLIC_DEPLOYMENT_NAME === 'main'
export const IS_DEMO_DEPLOYMENT = process.env.NEXT_PUBLIC_DEPLOYMENT_NAME === 'demo'

export const IS_PREVIEW_ENV = process.env.NEXT_PUBLIC_ENV as string === 'preview'
  || process.env.VERCEL_TARGET_ENV === 'preview'
  || IS_MAIN_DEPLOYMENT
  || IS_DEMO_DEPLOYMENT
  || IS_PLAYGROUND_DEPLOYMENT

export const IS_PLAYWRIGHT_CI = process.env.IS_PLAYWRIGHT_CI === 'true' || process.env.NEXT_PUBLIC_CI_TEST === 'true'
// True for every Playwright run, local as well as CI — set by `webServer.env` in playwright.config.ts.
// Must be NEXT_PUBLIC_ to reach the client bundle: `next dev` hardcodes process.env.NODE_ENV to
// 'development' there (see next/dist/build/define-env.js), so IS_TESTING_ENV is always false
// client-side and cannot be used to detect an E2E run.
export const IS_PLAYWRIGHT_RUN = process.env.NEXT_PUBLIC_PLAYWRIGHT === 'true' || IS_PLAYWRIGHT_CI
export const COMMIT_SHA = process.env.VERCEL_GIT_COMMIT_SHA as string
// currently unused (remove?), can only be used server-side
export const PACKAGE_VERSION = process.env.npm_package_version as string || ''
// Client-safe app version, inlined from package.json at build time via next.config.ts
export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION as string || ''
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN as string
export const SENTRY_ORG = process.env.NEXT_PUBLIC_SENTRY_ORG as string
export const SENTRY_PROJECT = process.env.NEXT_PUBLIC_SENTRY_PROJECT as string
export const IS_TESTING_ENV = process.env.NODE_ENV as string === 'test'

/**
 * Get site config map from config json string
 * @param {string | undefined} config - json string
 */
export const getSiteConfigMap = (config: string | undefined): Map<SiteKey, SiteEnv> => new Map(
  Object.entries(JSON.parse(config || '{}')),
) as Map<SiteKey, SiteEnv>

/**
 * Build config map from process.env JSON
 */
export const SITES_CONFIG_MAP = getSiteConfigMap(process.env.NEXT_PUBLIC_CONFIG)

// individual site configs
export const MW_TESTING_CONFIG = SITES_CONFIG_MAP.get('MW_TESTING') as SiteEnv
export const SAF_CONFIG = SITES_CONFIG_MAP.get('SAF') as SiteEnv
export const LVS_CONFIG = SITES_CONFIG_MAP.get('LVS') as SiteEnv
export const PREVIEW_CONFIG = SITES_CONFIG_MAP.get('PREVIEW') as SiteEnv

export const IS_CI_TEST_ENV = process.env.NEXT_PUBLIC_CI_TEST === 'true'
// NOTE: this is local auth0 only
export const LOCAL_BASE_URL = process.env.NEXT_PUBLIC_LOCAL_BASE_URL as string
export const VERCEL_URL = process.env.NEXT_PUBLIC_VERCEL_URL as string
